import React from 'react'
import { IJsonResponse } from 'core/JsonApiSerializer'
import { utilService } from 'core/services'
import * as constants from 'static/constants'
import { IFeature } from 'static/interfaces'
import styled from 'styled-components'
interface IProps {
  category_features: IJsonResponse
}

const CategoryFeatures: React.VFC<IProps> = ({ category_features }) => {
  const { data: categoryFeatures }: { data: IFeature[] } = utilService.getDataFromJson(
    category_features
  )

  return (
    <CategoryFeaturesWrapper>
      <div className="Scroller">
        {categoryFeatures.map((feature, index) => (
          <div className="Category_Feature" key={index}>
            <a href={`/features/${feature.slug}`}>{feature.title}</a>
          </div>
        ))}
      </div>
    </CategoryFeaturesWrapper>
  )
}

const CategoryFeaturesWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  padding: 0 100px;
  @media (max-width: ${constants.BREAKPOINT_DESKTOP_XL}px) {
    padding: 0 50px;
  }
  @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
    padding: 0 16px;
  }
  .Scroller {
    height: 48px;
    display: flex;
    gap: 20px;
    max-width: 1440px;
    margin: 0 auto;
  }
  .Category_Feature {
    flex: none;
    &:last-child {
      padding-right: 2.4rem;
    }
    a {
      font-size: 14px;
      color: ${constants.COLORS.primary};
      text-decoration: underline;
      &:hover {
        text-decoration: none;
      }
    }
  }
`
export default CategoryFeatures
